import * as types from '../constants';

export const initDoorlockListState = () => ({
  type: types.INIT_DOORLOCK_LIST_STATE,
});

export const setDoorlockList = doorlockList => ({
  type: types.SET_DOORLOCK_LIST,
  payload: doorlockList
});

export const setCurrentPageNumber = currentPageNumber => ({
  type: types.SET_DOORLOCK_LIST_CURRENT_PAGE_NUMBER,
  payload: currentPageNumber
});

export const setPaginationItem = paginationItem => ({
  type: types.SET_DOORLOCK_PAGINATION_ITEM,
  payload: paginationItem
});

export const setSortItem = sortItem => ({
  type: types.SET_DOORLOCK_SORT_ITEM,
  payload: sortItem
});

export const setFilterItem = filterItem => ({
  type: types.SET_DOORLOCK_FILTER_ITEM,
  payload: filterItem
});